import type { CallLogType } from 'Components/CallLogs/types';
import { formatDateGroup } from 'Utils/formatDateGroup';

type CallLogRowLayout = {
  showDateSeparator: boolean;
  removeTopPadding: boolean;
  removeBottomPadding: boolean;
  showTopBorder: boolean;
};

export const getCallLogRowLayout = (
  callLogs: Pick<CallLogType, 'startedAt'>[],
  index: number
): CallLogRowLayout => {
  const dateGroup = formatDateGroup(callLogs[index].startedAt);
  const prevDateGroup =
    index > 0 ? formatDateGroup(callLogs[index - 1].startedAt) : null;
  const nextDateGroup =
    index < callLogs.length - 1
      ? formatDateGroup(callLogs[index + 1].startedAt)
      : null;

  const isNewDateGroup = prevDateGroup === null || dateGroup !== prevDateGroup;
  const showDateSeparator = isNewDateGroup && dateGroup !== 'Today';
  const nextIsNewGroup = nextDateGroup !== null && nextDateGroup !== dateGroup;

  return {
    showDateSeparator,
    removeTopPadding: index === 0 || showDateSeparator,
    removeBottomPadding: nextIsNewGroup && nextDateGroup !== 'Today',
    showTopBorder: index > 0 && !showDateSeparator,
  };
};
